module.exports = __webpack_public_path__ + "static/media/teak.f04d3b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/teak.jpg
// module id = 41
// module chunks = 0